import { gql } from '@apollo/client'

export const GET_PICOS_STORE_COMPLIANCE = gql`
  query GetPicOSStoreCompliance($input: PicOSStoreComplianceInput!) {
    picosStoreCompliance(input: $input) {
      hasMore
      count
      results {
        id
        priority
        name
        description
        mandateType
        displayElements
        imageUrl
        cost
        isCompliant
        compliancePercentage
        activeDaysRemaining
        startDate
        endDate
      }
    }
  }
`
